import { AlertCircle, Check, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { AutosaveStatus } from "@/features/questionnaire/useAutosave";

export function SavingIndicator({ status, retrying, onRetry }: { status: AutosaveStatus; retrying: boolean; onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <div role="status" aria-live="polite" className="flex min-h-9 items-center gap-2 text-sm">
      {status === "saving" ? (
        <>
          <Loader2 aria-hidden="true" className="h-4 w-4 animate-spin text-fg-muted" />
          <span className="text-fg-muted">{t("questionnaire.saving")}</span>
        </>
      ) : null}
      {status === "saved" ? (
        <>
          <Check aria-hidden="true" className="h-4 w-4 text-success" />
          <span className="font-semibold text-success">{t("questionnaire.saved")}</span>
        </>
      ) : null}
      {status === "error" ? (
        <>
          <AlertCircle aria-hidden="true" className="h-4 w-4 text-danger" />
          <span className="font-semibold text-danger">{retrying ? t("questionnaire.saveRetrying") : t("questionnaire.saveFailed")}</span>
          {!retrying ? (
            <button type="button" onClick={onRetry} className="font-semibold text-heading underline">
              {t("questionnaire.tryAgain")}
            </button>
          ) : null}
        </>
      ) : null}
    </div>
  );
}
